export const possibleCatagories = [
  "Hero",
  "Testimonial",
  "Team",
  "Stats",
  "Pricing",
  "Logos",
  "Gallery",
  "Features",
  "FAQ",
  "Content",
  "Contact",
  "Card",
  "Slider",
  "CTA"
];
